import { Component, Input, ViewChild } from '@angular/core';
import { ReportingService } from '../../../models/reporting/reportingService';
import { PieChartComponent } from '../../ui/graphing/pie-chart/pie-chart.component';

@Component({
  selector: 'app-cardtype-chart',
  templateUrl: './cardtype-chart.component.html',
  standalone: false,
})
export class CardtypeChartComponent {
  @Input() chartType: string = 'pie'; // bar, line
  @Input() merchantId: string | undefined = undefined;
  @Input() duration: number = 12;

  @ViewChild('theChart') theChart: PieChartComponent | undefined;

  constructor(private reportingService: ReportingService) {}

  ngAfterViewInit() {
    let newData: any[] = [];

    newData.push({ year: 'Mastercard', count: 95 });
    newData.push({ year: 'Visa', count: 59 });
    newData.push({ year: 'Discover', count: 18 });
    newData.push({ year: 'AmEx', count: 3 });
    newData.push({ year: 'Other', count: 9 });

    let colors: any = {};
    colors.Mastercard = '#ff0000';
    colors.Visa = '#00ff00';
    colors.Discover = '#0000ff';
    colors.AmEx = '#00ffff';
    colors.Other = '#ffff00';

    if (this.theChart) {
      this.theChart.setData(newData, colors);
    }

    return;

    this.reportingService
      .getCardTypesReportData(this.merchantId)
      .then((reportData) => {
        if (this.theChart) {
          let newData: any[] = [];

          for (var i = 0; i < reportData.length; i++) {
            newData.push({
              year: reportData[i].label,
              count: reportData[i].value,
            });
          }

          this.theChart.setData(newData, {});
        }
      });
  }
}
